<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'product-release.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeId" (selectChange)="onStoreChanged($event)"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'product-release.data' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date"
                                    (selectChange)="applyFilters()"></hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'product-release.product' | transloco }}</small>
              <hx-product-info-select [(ngModel)]="params.productInfoIds" [types]="selectedPITypes" [multiple]="true" [brandId]="brandId" [disabled]="!brandId" (selectChange)="applyFilters()"></hx-product-info-select>
            </div>
          </div>

          <div class="m--margin-top-15">
            <button type="button" (click)="generate()" class="btn btn-outline-success m--margin-top-15 m--margin-right-10">
              {{ 'generate' | transloco }}
            </button>

            <button type="button" (click)="reset()" class="btn btn-outline-primary m--margin-top-15">
              {{ 'reset.list' | transloco }}
            </button>
          </div>

          <hr>

          <div
            class="table-responsive m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-20 m--margin-bottom-30">
            <table *ngIf="productReleaseList.length && !isLoading.list" class="m-datatable__table">
              <thead class="m-datatable__head">
              <tr class="m-datatable__row m-datatable__row--head">
                <th class="m-datatable__cell m-datatable__cell--fixed-col" style="height: 40%;">
                  <span>{{ 'product-release.table.head.productName' | transloco }}</span>
                </th>
                <th class="m-datatable__cell text-center">
                  <span>{{ 'product-release.table.head.itemCode' | transloco }}</span>
                </th>
                <th class="m-datatable__cell text-center">
                  <span>{{ 'product-release.table.head.measurement' | transloco }}</span>
                </th>
                <th class="m-datatable__cell text-center">
                  <span>{{ 'product-release.table.head.quantity' | transloco }}</span>
                </th>
              </tr>
              </thead>
              <tbody class="m-datatable__body">
              <ng-container *ngFor="let even = even;let i = index; let productRelease of productReleaseList">
                <tr class="m-datatable__row"
                    [ngClass]="{ 'm-datatable__row--even': even }">
                  <td class="m-datatable__cell m-datatable__cell--fixed-col">
                    {{ productRelease.productTitle | uiLabel }}
                  </td>
                  <td class="m-datatable__cell text-center">
                    {{ productRelease.productExt1cCode }}
                  </td>
                  <td class="m-datatable__cell text-center">
                    {{ productRelease.unitOfMeasureTitle | uiLabel }}
                  </td>
                  <td class="m-datatable__cell text-center">
                    {{ productRelease.productAmount }}
                  </td>
                </tr>
              </ng-container>
              </tbody>
            </table>
            <hx-loader [length]="productReleaseList.length" [isLoading]="isLoading.list"></hx-loader>
          </div>
          <div class="m--align-center"
               *ngIf="productReleaseList.length && !isLoading.list && pagination.allItemCount > 0">
            <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                            [(page)]="params.page" [pageSize]="params.limit" (pageChange)="pageChanged($event)"
                            class="d-flex justify-content-center mt-4">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
